var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c("div", [
        _c("div", { staticClass: "filter-sidebar" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isShowOnlyPremium,
                  expression: "isShowOnlyPremium"
                }
              ],
              attrs: { type: "checkbox", id: "only-show-premium-video" },
              domProps: {
                checked: Array.isArray(_vm.isShowOnlyPremium)
                  ? _vm._i(_vm.isShowOnlyPremium, null) > -1
                  : _vm.isShowOnlyPremium
              },
              on: {
                change: function($event) {
                  var $$a = _vm.isShowOnlyPremium,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isShowOnlyPremium = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isShowOnlyPremium = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isShowOnlyPremium = $$c
                  }
                }
              }
            }),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.sort,
                    expression: "sort"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.sort = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [_vm._v("公開日順")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "likes" } }, [
                  _vm._v("いいね数順")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "comments" } }, [
                  _vm._v("コメント数順")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "video-grid", attrs: { id: "videoGrid" } },
          _vm._l(_vm.videos, function(video) {
            return _c(
              "a",
              {
                key: video.id,
                staticClass: "video-link",
                attrs: { title: video.title },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    _vm.handleClickViewVideo(video)
                  }
                }
              },
              [
                video.isTargetPremium
                  ? _c("div", { staticClass: "premium-badge" }, [
                      _c("i", {
                        staticClass: "fa fa-diamond",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v("\n        プレミアム\n      ")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "video-card" }, [
                  _c("img", {
                    staticClass: "thumbnail",
                    attrs: {
                      src: video.thumbnail,
                      alt: video.title,
                      loading: "lazy"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "video-info" }, [
                    _c("div", {
                      staticClass: "channel-avatar",
                      style: {
                        backgroundImage:
                          "url(" +
                          _vm.categories["" + video.category].iconUrl +
                          ")"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "video-title",
                          attrs: { title: video.title }
                        },
                        [_vm._v(_vm._s(video.title))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-gray" }, [
                        _c("div", { staticClass: "category-name" }, [
                          _vm._v(
                            _vm._s(_vm.categories["" + video.category].name)
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flexbox gap-10" }, [
                          _c("span", [_vm._v(" " + _vm._s(video.createDate))]),
                          _vm._v(" "),
                          _c("span", [
                            _c("i", {
                              staticClass: "fa fa-thumbs-up",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(video.likes) +
                                "\n                "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _c("i", {
                              staticClass: "fa fa-comments-o",
                              attrs: { "aria-hidden": "true" }
                            }),
                            _vm._v(
                              "\n                  " +
                                _vm._s(video.comments) +
                                "\n                "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "only-show-premium-video" } }, [
      _c("i", {
        staticClass: "fa fa-diamond",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v("\n        プレミアム限定動画のみ表示する\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01058574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01058574","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/video/VideoList.vue
// module id = null
// module chunks = 